import React, { Component } from 'react'
import { Box } from '@mui/material'

import AppDialog from '@/shared/ui/app-dialog/AppDialog'
import { StyledButton } from '@/shared/ui/buttons'
class ConfirmRedirectWebpageDialog extends Component {
    constructor(props) {
        super(props)

        this.state = {
            submitting: false,
        }
    }

    generateDialogFooter() {
        return (
            <>
                <StyledButton onClick={this.props.accept}>
                    {this.props.kedo.t('Continue')}
                </StyledButton>{' '}
                &nbsp;
                <StyledButton
                    onClick={() => this.props.cancel()}
                    color="secondary"
                >
                    {this.props.kedo.t('Cancel')}
                </StyledButton>
            </>
        )
    }

    getForm() {
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'lg'}
                fullWidth
                title={this.props.kedo.t('Confirm')}
                onClose={() => this.props.cancel()}
                headerClose={() => this.props.cancel()}
                contentProps={{ dividers: true }}
                actions={this.generateDialogFooter()}
            >
                <Box component="form">
                    {this.props.kedo.t('confirm_redirect_changes')}
                </Box>
            </AppDialog>
        )
    }

    render() {
        return this.getForm()
    }
}

export default ConfirmRedirectWebpageDialog
